import { Controller, useFormContext } from "react-hook-form";
import Select from "../../../UI/Select";

interface Props {
    teamList: string[];
}

export default function UserTeamSelect({ teamList }: Props) {
    const { watch, setValue, control } = useFormContext();
    const team = watch("team_slug");

    return (
        <Controller
            name='team_slug'
            control={control}
            render={({ field }) => (<Select
                options={teamList}
                value={field.value}
                isChangeable
                placeholder="Команда"
                setValue={setValue}
                formName={field.name}
                classes={{
                    select: "universaleditmodal-right-content-select",
                    select_wrapper: "universaleditmodal-right-content-region",
                    select_option: "universaleditmodal-right-content-region-option",
                    select_placeholder:
                        "universaleditmodal-right-content-region-placeholder",
                }}
            />
            )}
        />)
}